import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

export const abandonDocument = createAsyncThunk(
  "documentUpdate/abandonDocument",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { id: documentId } = state.documentShow.document;
      const user = state.userAuthentication.user

      const { data } = await axiosInstance.post(`${api.baseURL}document/abandon-document`, {
        documentId, user
      });

      return data as Document;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
